import { refDebounced } from '@vueuse/core';

const SEARCH_DEBOUNCE_MS = 250;

/**
 * The search to query with: typing settles once it pauses, while `settle` applies a value at once
 * (a keyword arriving from the URL). Both trim, so every search box agrees on what was searched.
 */
export const useSettledSearch = (typed: () => string) => {
  const settled = ref(typed().trim());
  watch(refDebounced(computed(typed), SEARCH_DEBOUNCE_MS), (value) => {
    settled.value = value.trim();
  });
  const settle = (value: string) => {
    settled.value = value.trim();
  };

  return { settled, settle };
};
